import React, { useMemo } from "react"
import { Chip, Stack } from "@mui/material"

const IntervalCalendarOptions = ({ options = [], selectedOption = null, onSelect }) => {
  // Compute the longest label length
  const longestLabel = useMemo(() => {
    if (!options.length) return 0
    return options.reduce((max, opt) => Math.max(max, opt.label.length), 0)
  }, [options])

  // Approximate chip width per character (tweak depending on font-size)
  const chipWidth = longestLabel * 10 + 32 // 10px per char + padding

  return (
    <Stack
      direction="column"
      spacing={1}
      alignSelf={"start"}
      alignItems="center">
      {options.map((option, index) => (
        <Chip
          key={index}
          label={option.label}
          onClick={() => onSelect && onSelect(option)}
          color={option === selectedOption ? "primary" : "default"}
          sx={{
              fontSize: 14,
              padding: "8px 16px",
              minWidth: chipWidth
          }}
        />
      ))}
    </Stack>
  )

}

export default IntervalCalendarOptions